(function () {
  'use strict';

  /* ── Star renderer ──────────────────────────────────────── */
  function starSVG(type) {
    return type === 'full'
      ? '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5 20.4l1.4-6.8L1.3 9l6.9-.7z"/></svg>'
      : '<svg viewBox="0 0 24 24" style="opacity:.25"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5 20.4l1.4-6.8L1.3 9l6.9-.7z"/></svg>';
  }

  document.querySelectorAll('.sour-page [data-stars], .sour-widget [data-stars]').forEach(function (el) {
    var val  = parseFloat(el.getAttribute('data-stars')) || 0;
    var full = Math.round(val);
    var html = '';
    for (var i = 1; i <= 5; i++) html += starSVG(i <= full ? 'full' : 'empty');
    el.innerHTML = html;
  });

  /* ── Read-more toggle (stories + quote cards) ───────────── */
  document.querySelectorAll('.sour-readmore').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.sour-story') || btn.closest('.sour-qcard');
      if (!card) return;
      var open = card.classList.toggle('open');
      btn.innerHTML = open ? 'Read less &rsaquo;' : 'Read more &rsaquo;';
    });
  });

  /* ── Load more: short quote wall ───────────────────────── */
  var loadQBtn = document.getElementById('sourLoadQ');
  if (loadQBtn) {
    loadQBtn.addEventListener('click', function () {
      document.querySelectorAll('#sourQwall .sour-hidden-more').forEach(function (card) {
        card.style.display = '';
        card.classList.add('in');
      });
      loadQBtn.style.display = 'none';
    });
  }

  /* ── Reviews widget: filter + sort + paginated load-more ── */
  var rfeed    = document.getElementById('sourRfeed');
  var loadRBtn = document.getElementById('sourLoadR');

  if (rfeed) {
    var rcards  = Array.prototype.slice.call(rfeed.querySelectorAll('.sour-rcard'));
    var wchips  = document.querySelectorAll('#sourWfilters .sour-chip');
    var wsort   = document.getElementById('sourWsort');
    var wFilter = 'all';

    var PAGE_SIZE    = 12;   /* cards shown on initial load / per "Load more" click */
    var visibleCount = PAGE_SIZE;
    var sortedVisible = [];  /* current filtered+sorted list, rebuilt on filter/sort change */

    function buildSortedVisible() {
      sortedVisible = rcards.filter(function (c) {
        return wFilter === 'all' || c.dataset.product === wFilter;
      });

      var sortVal = wsort ? wsort.value : 'recent';
      sortedVisible.sort(function (a, b) {
        if (sortVal === 'recent')  return new Date(b.dataset.date)  - new Date(a.dataset.date);
        if (sortVal === 'helpful') return (+b.dataset.helpful)      - (+a.dataset.helpful);
        if (sortVal === 'high')    return (+b.dataset.rating)       - (+a.dataset.rating);
        if (sortVal === 'low')     return (+a.dataset.rating)       - (+b.dataset.rating);
        return 0;
      });
    }

    function renderPage() {
      /* Hide all cards first, then show the first visibleCount from sortedVisible */
      rcards.forEach(function (c) { c.style.display = 'none'; });
      var toShow = sortedVisible.slice(0, visibleCount);
      toShow.forEach(function (c) {
        c.style.display = '';
        rfeed.appendChild(c);   /* re-order DOM to match sort */
      });

      /* Show/hide Load more button */
      if (loadRBtn) {
        if (visibleCount >= sortedVisible.length) {
          loadRBtn.style.display = 'none';
        } else {
          loadRBtn.style.display = '';
          loadRBtn.disabled      = false;
          loadRBtn.textContent   = 'Load more reviews';
        }
      }
    }

    function applyWidget() {
      visibleCount = PAGE_SIZE;   /* reset to first page on every filter/sort change */
      buildSortedVisible();
      renderPage();
    }

    wchips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        wchips.forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
        wFilter = chip.dataset.filter;
        applyWidget();
      });
    });

    if (wsort) wsort.addEventListener('change', applyWidget);

    if (loadRBtn) {
      loadRBtn.addEventListener('click', function () {
        visibleCount += PAGE_SIZE;
        renderPage();
      });
    }

    /* Initial render */
    applyWidget();
  }

  /* ── Scroll-reveal (IntersectionObserver) ───────────────── */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.sour-page .reveal').forEach(function (el) { io.observe(el); });

  /* ── Lightbox ───────────────────────────────────────────── */
  var lb      = document.getElementById('sourLightbox');
  var lbMedia = document.getElementById('sourLbMedia');
  var lbName  = document.getElementById('sourLbName');
  var lbRole  = document.getElementById('sourLbRole');
  var lbClose = document.getElementById('sourLbClose');

  function openLB(name, role, video, img) {
    if (!lb) return;
    lbName.firstChild.textContent = name || 'Customer';
    lbRole.textContent = role ? ' · ' + role : '';
    if (video) {
      lbMedia.innerHTML = '<video src="' + video + '" controls autoplay playsinline></video>';
    } else if (img) {
      lbMedia.innerHTML = '<img src="' + img + '" alt="' + (name || '') + '">';
    } else {
      lbMedia.innerHTML = 'Add a clip URL to <code>data-video</code>, or a photo URL to <code>data-img</code>, on this tile.';
    }
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLB() {
    if (!lb) return;
    lb.classList.remove('open');
    lbMedia.innerHTML = '';
    document.body.style.overflow = '';
  }

  function bindLightbox(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener('click', function () {
        openLB(el.dataset.name, el.dataset.role, el.dataset.video, el.dataset.img);
      });
    });
  }

  bindLightbox('.sour-vcard');
  bindLightbox('.sour-gtile');

  if (lbClose) lbClose.addEventListener('click', closeLB);
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLB(); });

})();